import logger from '../services/logging/logging-service';

import { buildInfiniteScrollingArticlesUrl, getVideoSearchUrl } from './build-urls';

export const getVideoCarouselAssetsArray = async (tabData, baseUrl, hlPrevTags) => {
  let videoSearchUrl = '';
  videoSearchUrl = getVideoSearchUrl(tabData, baseUrl, hlPrevTags);
  if (videoSearchUrl) {
    const response = await fetch(videoSearchUrl);
    const parsedJson = await response.json();
    return parsedJson.assets || [];
  }
  return [];
};

const getInfiniteJson = async (url) => {
  const articlesUrl = buildInfiniteScrollingArticlesUrl(url);
  const response = await fetch(articlesUrl);
  const json = await response.json();
  return json;
};

export const getInfiniteData = async (dataURL) => {
  const articlesJson = await getInfiniteJson(dataURL);
  return articlesJson;
};

/**
 * injects the js into the head of the page,
 * accepts the js src(url) as a call back and parameters(object)
 */
export const loadScriptHead = (url, callback, params = {}) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
  script.addEventListener('load', () => {
    callback(params);
    logger.info('loadscriptHead has loaded');
  });
};
